'use client';

import { Button } from '@heroui/react';
import { FaMagnifyingGlass } from 'react-icons/fa6';
import { useScheduler } from '../SchedulerContext';

type ServiceSearchActionsProps = {
  onStartOver?: () => void;
  onSearch?: () => void;
};

export default function ServiceSearchActions({
  onStartOver,
  onSearch,
}: ServiceSearchActionsProps) {
  const { companyStyles } = useScheduler();

  const handleSearch = () => {
    if (onSearch) {
      onSearch();
    } else {
      // TODO: Implement search functionality
      console.log('Search for services');
    }
  };

  return (
    <div className='flex flex-col items-center gap-4 border-t pt-6'>
      <p className='text-sm text-gray-600'>
        Can&apos;t find what you&apos;re looking for?
      </p>
      <div className='flex gap-3'>
        <Button
          variant='flat'
          startContent={<FaMagnifyingGlass />}
          onPress={handleSearch}
          className={companyStyles.secondaryButtonClassName}
          style={companyStyles.secondaryButtonStyles}
        >
          Search for Services
        </Button>
        {onStartOver && (
          <Button
            onPress={onStartOver}
            variant='bordered'
            // className={companyStyles.secondaryButtonClassName}
            // style={companyStyles.secondaryButtonStyles}
          >
            Start Questions Over
          </Button>
        )}
      </div>
    </div>
  );
}
